import { render, staticRenderFns } from "./Tramitados.vue?vue&type=template&id=3f9dceae&scoped=true"
import script from "./Tramitados.vue?vue&type=script&lang=js"
export * from "./Tramitados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9dceae",
  null
  
)

export default component.exports